export const toBase64 = file => new Promise((resolve, reject) => {  // convert file to base64;
    const reader = new FileReader();
    if(file){
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    }else{
        resolve(false)
    }
});

export const resizeBase64Img = (base64, newWidth)=> {
    return new Promise((resolve, reject)=>{
        let canvas = document.createElement("canvas");
        let img = document.createElement("img");
        img.src = base64;
        img.onload = function () {
            canvas.width = newWidth;
            canvas.height = (newWidth * (img.height / img.width)).toFixed(0);
            let context = canvas.getContext("2d");
            context.scale(newWidth/img.width, newWidth/img.width);
            context.drawImage(img, 0, 0); 
            resolve(canvas.toDataURL("image/jpeg"));               
        }
    });  
}